class Login {
  buttons: NodeListOf<HTMLAnchorElement>;
  popup: HTMLDivElement | null;
  form: HTMLFormElement | null;
  closeBtn: HTMLButtonElement | null;

  constructor() {
    this.buttons = document.querySelectorAll(".topMenu__link--login");
    this.popup = document.querySelector(".login-popup");
    this.form = document.querySelector(".login-popup__form");
    this.closeBtn = document.querySelector(".login-popup__close");

    if (this.buttons.length && this.popup && this.form) {
      this.init();
    }
  }

  init() {
    this.buttons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.open();
      });
    });

    this.closeBtn?.addEventListener("click", () => {
      this.close()
    });

    this.popup!.addEventListener("click", (e) => {
      if (!this.form!.contains(e.target as Node)) {
        this.close();
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.close();
      }
    });
  }

  open() {
    this.popup!.hidden = false;
    this.popup!.classList.add("active");
    document.body.classList.add("popup-open");

    this.buttons.forEach(button => {
      button.setAttribute('aria-expanded', 'true');
    });

    const main = document.querySelector<HTMLElement>(".main");
    main!.inert = true;
    const header = document.querySelector<HTMLElement>(".header");
    header!.inert = true;
    const footer = document.querySelector<HTMLElement>(".footer");
    footer!.inert = true;
  }

  close() {
    this.popup!.hidden = true;
    this.popup!.classList.remove("active");
    document.body.classList.remove("popup-open");

  this.buttons.forEach(button => {
    button.setAttribute('aria-expanded', 'false');
  });

    const main = document.querySelector<HTMLElement>(".main");
    main!.inert = false;
    const header = document.querySelector<HTMLElement>(".header");
    header!.inert = false;
    const footer = document.querySelector<HTMLElement>(".footer");
    footer!.inert = false;
  }
}

export const login = new Login();
